import { render } from "./portfolio-contact-person.vue?vue&type=template&id=9d7c1738&scoped=true&ts=true"
import script from "./portfolio-contact-person.vue?vue&type=script&lang=ts"
export * from "./portfolio-contact-person.vue?vue&type=script&lang=ts"

import "./portfolio-contact-person.vue?vue&type=style&index=0&id=9d7c1738&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d7c1738"]])

export default __exports__